
import BusRatesTable from './BusRatesTable';
import './smallkey.css';
import { Helmet } from 'react-helmet';
import TestimonialKeyword from './TestimonialKeyword';
import FAQKeyword from './FAQKeyword';

function Punwtorajashthandarshan() {



    const cardData =
    {
        keyword: 'Pune to Rajasthan Darshan Bus Package',
        heading: 'Amruta Travels: Pune to Rajasthan Darshan Bus Package',
        headingDescription: 'Amruta Travels offers Rajasthan Darshan Tour Package from Pune, providing a comprehensive and spiritually enriching journey to the twelve sacred Jyotirlinga shrines across India. This meticulously planned pilgrimage covers revered temples such as Somnath, Mallikarjuna, Mahakaleshwar, Omkareshwar, Kedarnath, Bhimashankar, Kashi Vishwanath, Trimbakeshwar, Vaidyanath, Nageshwar, Rameshwar, and Grishneshwar. Our well-maintained fleet, including 17-seater, 32-seater, and 50-seater buses, ensures a comfortable and safe journey for all devotees. With experienced drivers, knowledgeable tour guides, affordable pricing, and 24/7 support, Amruta Travels makes your 12 Jyotirlinga Darshan from Pune a seamless and memorable spiritual experience. Book your pilgrimage with us today and embark on a journey of devotion and discovery!',


        top: 'Top Places to Visit in Rajasthan with Amruta Travels',
"topPlaces": [
  {
    "title": "Jaipur – The Pink City",
    "description": "Rajasthan's capital, Jaipur, is famed for its pink-hued architecture and rich history. Key attractions include the Hawa Mahal, Amber Fort, City Palace, and Jantar Mantar. The city offers a blend of royal heritage and vibrant markets."
  },
  {
    "title": "Udaipur – The City of Lakes",
    "description": "Known for its serene lakes and palatial structures, Udaipur boasts attractions like the City Palace, Lake Pichola, and Jag Mandir. The city's romantic ambiance makes it a favorite among travelers."
  },
  {
    "title": "Jodhpur – The Blue City",
    "description": "Dominated by the imposing Mehrangarh Fort, Jodhpur's blue-painted houses create a mesmerizing skyline. Other highlights include Jaswant Thada and the bustling Sardar Market."
  },
  {
    "title": "Jaisalmer – The Golden City",
    "description": "Rising from the Thar Desert, Jaisalmer is renowned for its golden sandstone architecture. The Jaisalmer Fort, Patwon Ki Haveli, and desert safaris offer a unique experience."
  },
  {
    "title": "Pushkar",
    "description": "A sacred town centered around Pushkar Lake, it's home to one of the few Brahma temples in the world. The annual Pushkar Camel Fair attracts visitors globally."
  },
  {
    "title": "Mount Abu",
    "description": "Rajasthan's only hill station, Mount Abu offers a cool retreat with attractions like the Dilwara Temples, Nakki Lake, and Guru Shikhar."
  },
  {
    "title": "Ranthambore National Park",
    "description": "A premier wildlife destination, Ranthambore is famed for its tiger population. The park also houses the historic Ranthambore Fort."
  },
  {
    "title": "Chittorgarh",
    "description": "Home to the massive Chittorgarh Fort, this city narrates tales of Rajput valor and sacrifice. Key sites include the Vijay Stambh and Rana Kumbha Palace."
  },
  {
    "title": "Bikaner",
    "description": "Known for the Junagarh Fort and the Karni Mata Temple (Rat Temple), Bikaner offers a mix of history and unique cultural experiences."
  },
  {
    "title": "Ajmer",
    "description": "A spiritual hub, Ajmer is renowned for the Ajmer Sharif Dargah, attracting devotees from all faiths."
  }
],



    "services": [
    {
      "name": "Pune to Jaipur Bus On Rent",
      "description": "Amruta Travels offers comfortable and reliable bus rental services from Pune to Jaipur. Ideal for family trips, corporate outings, or tourism, our buses come with experienced drivers, AC options, and spacious seating for a smooth long-distance journey."
    },
    {
      "name": "Pune to Jodhpur Bus On Rent",
      "description": "Travel from Pune to the vibrant city of Jodhpur with Amruta Travels. Our well-maintained buses ensure a comfortable and scenic ride, ideal for Rajasthan exploration, group trips, or cultural tours."
    },
    {
      "name": "Pune to Mount Abu Bus on Rent",
      "description": "Book a relaxing hill station getaway from Pune to Mount Abu with Amruta Travels. Our AC and Non-AC buses are ideal for nature lovers, family groups, or spiritual travelers visiting the Dilwara Temples and scenic landscapes."
    },
    {
      "name": "Pune to Jaisalmer Bus Packages",
      "description": "Explore the golden city of Jaisalmer with our special Pune to Jaisalmer bus packages. Amruta Travels provides convenient and affordable travel solutions for desert tours, heritage visits, and Rajasthan vacations."
    },
    {
      "name": "Pune to Rajasthan Darshan Bus Packages",
      "description": "Amruta Travels offers all-inclusive Rajasthan Darshan bus packages from Pune. Cover iconic cities like Jaipur, Udaipur, Jodhpur, and Jaisalmer in a comfortable and planned group travel setup, perfect for families and corporate groups."
    },
    {
      "name": "32 Seater Bus for Pune to Rajasthan",
      "description": "Hire a 32-seater bus for your Rajasthan trip from Pune with Amruta Travels. Our buses are equipped with comfortable seating, ample luggage space, and professional drivers for long-distance travel comfort."
    },
    {
      "name": "Pune to Rajasthan Darshan Bus Hire",
      "description": "Plan a Rajasthan Darshan with our premium bus rental service from Pune. Suitable for pilgrimages, tourism, or educational tours, Amruta Travels provides dependable service with full customization options."
    },
    {
      "name": "Pune to Rajasthan Road Trip Bus Booking from Pune",
      "description": "Book your Rajasthan road trip bus from Pune with Amruta Travels. Our flexible rental plans and comfortable buses are ideal for exploring Rajasthan’s palaces, forts, and desert landscapes in a memorable group journey."
    },
    {
      "name": "Pune to Rajasthan Udaipur Bus on Rent for Picnic",
      "description": "Visit the city of lakes—Udaipur—with our picnic bus rental service from Pune. Amruta Travels offers ideal transportation for group picnics, family holidays, or romantic getaways to Udaipur with safety and comfort ensured."
    },
    {
      "name": "Mini Bus on Rent Pune for Rajasthan Trip",
      "description": "Amruta Travels provides mini buses from Pune to Rajasthan, ideal for smaller groups wanting an affordable and convenient travel solution. Perfect for sightseeing tours and personalized family packages."
    },
    {
      "name": "Pune to Rajasthan Bus Trip Packages",
      "description": "Enjoy customized Rajasthan bus trip packages from Pune with Amruta Travels. Our packages include travel, sightseeing, and flexible itineraries to fit your group’s needs while ensuring quality and safety."
    },
    {
      "name": "Pune to Rajasthan Volvo Bus Service",
      "description": "Travel in luxury with our Pune to Rajasthan Volvo bus service. Amruta Travels offers premium Volvo buses equipped with reclining seats, AC, and entertainment systems for a relaxed and smooth interstate journey."
    },
    {
      "name": "Pune to Rajasthan Sleeper Bus Hire",
      "description": "For overnight travel comfort, hire sleeper buses from Pune to Rajasthan with Amruta Travels. Our sleeper coaches are perfect for long journeys, ensuring passengers arrive rested and refreshed."
    },
    {
      "name": "Rent a Bus for a Trip",
      "description": "Planning a long-distance or multi-day trip? Amruta Travels offers reliable bus rentals for trips from Pune to any destination, including Rajasthan. Choose from various seating capacities and bus types to suit your travel needs."
    }
  ],
  "tableData": [
    ["Pune to Jaipur Bus On Rent", "Pune to Jodhpur Bus On Rent"],
    ["Pune to Mount Abu Bus on Rent", "Pune to Jaisalmer Bus Packages"],
    ["Pune to Rajasthan Darshan Bus Packages", "32 Seater Bus for Pune to Rajasthan"],
    ["Pune to Rajasthan Darshan Bus Hire", "Pune to Rajasthan Road Trip Bus Booking from Pune"],
    ["Pune to Rajasthan Udaipur Bus on Rent for Picnic", "Mini Bus on Rent Pune for Rajasthan Trip"],
    ["Pune to Rajasthan Bus Trip Packages", "Pune to Rajasthan Volvo Bus Service"],
    ["Pune to Rajasthan Sleeper Bus Hire", "Rent a Bus for a Trip"]
  ],


"whychoose": [
  {
    "WhyChooseheading": "Explore Royal Rajasthan with Our Pune to Rajasthan Darshan Bus Package",
    "WhyChoosedescription": "Amruta Travels presents a specially curated Pune to Rajasthan Darshan Bus Package that takes you through the majestic forts, palaces, and rich heritage of the Land of Kings. Travel in comfort while experiencing the cultural beauty of Jaipur, Udaipur, Jodhpur, Jaisalmer, and other iconic cities, all in one seamless journey."
  },
  {
    "WhyChooseheading": "Comfortable Travel with Well-Maintained Buses",
    "WhyChoosedescription": "Our Rajasthan tour buses are fully equipped for long-distance travel with comfortable push-back seats, air conditioning, large windows for scenic views, and plenty of luggage space. Choose from 32, 35, 40, 45, or 50-seater buses to suit your group size and travel requirements, ensuring a relaxed and enjoyable journey across states."
  },
  {
    "WhyChooseheading": "Visit Iconic Destinations Across Rajasthan",
    "WhyChoosedescription": "This bus tour package covers Rajasthan’s must-visit sites including Jaipur’s Amber Fort and City Palace, Udaipur’s Lake Pichola and City Palace, Jodhpur’s Mehrangarh Fort, Jaisalmer’s Golden Fort and Sam Sand Dunes, and many more. We ensure that you experience the best of Rajasthan’s history, architecture, and culture."
  },
  {
    "WhyChooseheading": "Experienced Drivers and Tour Support Staff",
    "WhyChoosedescription": "Our experienced drivers are skilled in long-distance interstate travel and are familiar with routes throughout Rajasthan. Each tour is also supported by a knowledgeable tour coordinator or guide (optional) to assist with local arrangements, sightseeing entry points, and timely coordination at every stop."
  },
  {
    "WhyChooseheading": "Affordable Pricing with Inclusive Packages",
    "WhyChoosedescription": "We offer all-inclusive Rajasthan Darshan packages from Pune at affordable rates, covering bus transport, accommodation (budget to deluxe options), and sightseeing. Transparent pricing ensures there are no hidden costs, helping you enjoy your royal journey without budget concerns."
  },
  {
    "WhyChooseheading": "Clean, Hygienic, and Safe Travel Experience",
    "WhyChoosedescription": "All our buses are sanitized before every trip and undergo regular maintenance. We prioritize safety, cleanliness, and passenger comfort throughout the journey. With comfortable rest stops, clean seating, and a dedicated team, we ensure your trip remains stress-free and enjoyable."
  },
  {
    "WhyChooseheading": "Flexible Tour Plans and Custom Group Packages",
    "WhyChoosedescription": "Whether you’re a family group, senior citizen group, school, or corporate team, we offer customizable Rajasthan tour plans based on your preferences. You can add destinations, extend stays, or tailor the itinerary to suit your travel needs and pace."
  },
  {
    "WhyChooseheading": "Easy Booking and Reliable Support Team",
    "WhyChoosedescription": "Booking your Rajasthan Darshan tour from Pune is simple with Amruta Travels. You can reserve your package online, over the phone, or at our office. Our customer service team is available 24/7 to assist with queries, itinerary customization, and travel updates throughout your journey."
  }
]














    }

const faqData = [
  {
    question: 'What is included in the Pune to Rajasthan Darshan bus package?',
    answer: 'The Pune to Rajasthan Darshan package includes round-trip AC bus travel, hotel accommodation, meals, sightseeing to key destinations in Rajasthan like Jaipur, Udaipur, Jodhpur, and Jaisalmer, and a dedicated tour guide throughout the journey.',
  },
  {
    question: 'How long is the Rajasthan Darshan tour from Pune?',
    answer: 'The typical Rajasthan Darshan tour from Pune lasts between 8 to 10 days, depending on the final itinerary and selected sightseeing spots. Customization is available for group bookings.',
  },
  {
    question: 'What type of buses are provided for the Rajasthan tour?',
    answer: 'We offer comfortable AC and luxury buses including 32, 40, and 45-seater coaches with push-back seats, large windows, and ample luggage space to ensure a pleasant long-distance journey.',
  },
  {
    question: 'Are meals and accommodation included in the Rajasthan tour package?',
    answer: 'Yes, the package includes hygienic vegetarian meals (breakfast and dinner) and stays at clean, verified hotels or guesthouses throughout the journey.',
  },
  {
    question: 'Can I customize the Rajasthan tour from Pune for my group?',
    answer: 'Absolutely! We offer customizable Rajasthan Darshan packages for families, corporate groups, and tour organizers. You can modify the itinerary, travel dates, accommodation category, and more.',
  },
  {
    question: 'Is a guide provided during the Rajasthan tour?',
    answer: 'Yes, we provide a knowledgeable tour guide who assists with sightseeing, historical insights, and smooth coordination at each destination.',
  },
  {
    question: 'What destinations are covered in the Rajasthan Darshan tour?',
    answer: 'Our standard Rajasthan tour includes Jaipur (Pink City), Jodhpur (Blue City), Udaipur (Lake City), Jaisalmer (Golden City), Mount Abu, and Ajmer-Pushkar. You can also customize to include other locations.',
  },
  {
    question: 'How much does the Rajasthan bus tour package from Pune cost?',
    answer: 'Pricing depends on group size, duration, bus type, and accommodation preferences. Contact us with your group details for a customized quote.',
  },
  {
    question: 'Why choose Amruta Travels for the Rajasthan Darshan tour?',
    answer: 'Amruta Travels is trusted for well-organized, value-packed group tours. We provide quality buses, reliable drivers, comfortable stays, and personalized assistance to make your Rajasthan Darshan memorable.',
  },
];

const testimonialsData = [
  {
    id: 1,
    name: 'Mr. Dinesh Patil',
    role: 'Family Group Organizer, Pune',
    text: 'We recently booked the Rajasthan Darshan package with Amruta Travels. The bus was extremely comfortable, and the tour was very well managed. Our group had a fantastic experience exploring Jaipur, Udaipur, and Jaisalmer.',
    rating: 5,
  },
  {
    id: 2,
    name: 'Mrs. Manisha Agarwal',
    role: 'Senior Citizen Group Member',
    text: 'Excellent Rajasthan tour! The guide was knowledgeable, the driver was polite, and accommodations were clean. The team took great care of senior members like me. Highly recommend Amruta Travels.',
    rating: 5,
  },
];



























































    const contactData = {
        heading: `${cardData.keyword} Contact Number`,
        contactNumbers: [
            "+91 7353109555",
            "+91 7090597555",
            "+91 7887774499",

        ],
        email: "booking@bushireinpune.com"
    };


    const Images = [
        {
            place: "/images/keyword/1.jpg",
            text: "Bus Hire For Wedding in Pune",
        },
        {
            place: "/images/keyword/2.jpg",
            text: " Buses For Corporate Events",
        },
        {
            place: "/images/keyword/3.jpg",
            text: "25 Seater Tempo Traveller on Rent in Pune",
        },
        {
            place: "/images/keyword/4.jpg",
            text: "32 Seater Bus Rent in Pune",
        },
        {
            place: "/images/keyword/5.jpg",
            text: "35 Seater Bus on Rent in Pune",
        },
        {
            place: "/images/keyword/6.jpg",
            text: "45 Seater Bus on Rent in Pune",
        },
        {
            place: "/images/keyword/7.jpg",
            text: "50 Seater Bus On Rent in Pune",
        },

        {
            place: "/images/keyword/8.jpg",
            text: "Pune to Shirdi Bus Hire",
        },

        {
            place: "/images/keyword/9.jpg",
            text: "Bus Rentals For School Trips in Pune",
        },
        {
            place: "/images/keyword/10.jpg",
            text: "Bus booking for wedding in Pune",
        },

        {
            place: "/images/keyword/11.jpg",
            text: "Bus Booking for Marriage",
        },
        {
            place: "/images/keyword/12.jpg",
            text: "Bus Service for Corporate Pune",
        },

        {
            place: "/images/keyword/13.jpg",
            text: "Bus on Rent For Event in Pune",
        },

        {
            place: "/images/keyword/14.jpg",
            text: "Bus Rental for Tour Packages",
        },
        {
            place: "/images/keyword/15.jpg",
            text: "Bus Hire for Outstation",
        },
        {
            place: "/images/keyword/16.jpg",
            text: " AC Bus On Rent in Pune",
        },
        {
            place: "/images/keyword/17.jpg",
            text: " Pune Bus Hire Rental Service",
        },
        {
            place: "/images/keyword/18.jpg",
            text: "Bus Service for Picnic in Pune ",
        },
        {
            place: "/images/keyword/19.jpg",
            text: "Non Ac Bus Rental Service in Pune",
        },
        {
            place: "/images/keyword/20.jpg",
            text: " Luxury Bus Rental in Pune",
        },

        {
            place: "/images/keyword/22.jpg",
            text: "Luxury Force Urbania On Rent in Pune ",
        },
        {
            place: "/images/keyword/23.jpg",
            text: "Pune to Bhimashankar Jyotirlinga Bus Hire in Pune ",
        },
        {
            place: "/images/keyword/24.jpg",
            text: " Pune to Alibaug Bus on Rent",
        },
        {
            place: "/images/keyword/25.jpg",
            text: " Pune to Ganpatipule Beach Bus Rental Service ",
        },
        {
            place: "/images/keyword/26.jpg",
            text: " Pune to 5 Jyotirlinga Darshan Bus Hire",
        },
    ];


    const images = [
        { src: "/images/gallery/24.jpg", alt: "Image 1" },
        { src: "/images/gallery/28.jpg", alt: "Image 1" },
        { src: "/images/gallery/2.jpg", alt: "Image 1" },
        { src: "/images/gallery/3.jpg", alt: "Image 1" },
        { src: "/images/gallery/24.jpg", alt: "Image 1" },
        { src: "/images/gallery/27.jpg", alt: "Image 1" },
        { src: "/images/gallery/29.jpg", alt: "Image 1" },
        { src: "/images/gallery/30.jpg", alt: "Image 1" },
        { src: "/images/gallery/31.jpg", alt: "Image 1" },

    ];







const productSchema = {
  "@context": "https://schema.org",
  "@type": "Product",
  "name": "Pune to Rajasthan Darshan Bus Package",
  "image": "https://bushireinpune.com/assets/images/pune-to-rajasthan-bus-package.jpg",
  "description": "Explore Rajasthan with a dedicated bus package from Pune. Visit iconic destinations like Jaipur, Jodhpur, Mount Abu, and Jaisalmer with our comfortable buses. We offer 32-seater, Volvo, and sleeper bus options for your Rajasthan road trip, along with affordable pricing and excellent service.",
  "brand": {
    "@type": "Brand",
    "name": "Amruta Travels"
  },
  "aggregateRating": {
    "@type": "AggregateRating",
    "bestRating": "5",
    "worstRating": "1",
    "ratingValue": "4.8",
    "ratingCount": "5100"
  },
  "offers": {
    "@type": "Offer",
    "priceCurrency": "INR",
    "price": "6799",
    "availability": "https://schema.org/InStock",
    "url": "https://bushireinpune.com/pune-to-rajasthan-darshan-bus-package"
  }
};




    return (
        <div>
<Helmet>
  <title>Call: +91 7353109555 | Pune to Rajasthan Darshan Bus Package | Visit Jaipur, Jodhpur, Mount Abu & More</title>
  <meta 
    name="description" 
    content="Book a bus package for a Rajasthan Darshan tour from Pune. Visit popular destinations like Jaipur, Jodhpur, Mount Abu, and Jaisalmer with comfortable 32-seater, Volvo, and sleeper buses for your journey." 
  />
  <script type="application/ld+json">
    {JSON.stringify(productSchema)}
  </script>
</Helmet>



            <section className="breadcrumb-outer text-center">
                <div className="container">
                    <div className="breadcrumb-content">
                        <h2 className="white text-center">{cardData.keyword} </h2>
                    </div>
                </div>
                <div className="overlay"></div>
            </section>





            <section id="about" className="jarallax text-light">
                <div className="center-y relative text-center">
                    <div className="container">
                        <div className="row">
                            <div className="col-md-12 text-center">
                                {/* <h1 className='text-white'>{cardData.keyword}</h1> */}
                            </div>
                            <div className="clearfix"></div>
                        </div>
                    </div>
                </div>
            </section>

            <section>
                <div className="container-fluid" >
                    <div className="row ">
                        <div className="col-12 col-md-7 ">
                            <img src='/images/keyword/50.jpg' alt='img' />
                            <h3 className="py-1"
                                style={{
                                    color: '#322E77', // Red color for the title 
                                    textShadow: '5px 5px 10px rgba(255, 255, 255, 0.7)', // Light shadow effect
                                    fontWeight: 'bold'
                                }}


                            >{cardData.heading} </h3><p className='fw-bold '>{cardData.headingDescription}</p>
                            <div className="">
                                <p className='fw-bold py-3 darkcolorrr'>{cardData.top}</p>
                                {cardData.topPlaces.map((place, index) => (
                                    <div key={index} className="">
                                        <div
                                            style={{
                                                cursor: 'pointer',
                                                padding: '10px',
                                                marginBottom: '7px',
                                                borderRadius: '8px',
                                                transition: 'transform 0.2s'
                                            }}

                                        >
                                            <h4 className="mb-1 darkcolorrr">{place.title}</h4>
                                            <p className="mb-0">{place.description}</p>
                                        </div>
                                    </div>
                                ))}
                            </div>
                            <div
                                style={{
                                    cursor: 'pointer',
                                    padding: '10px',
                                    marginBottom: '7px',
                                    borderRadius: '8px', // Optional: rounded corners
                                    transition: 'transform 0.2s' // Optional: smooth scaling effect
                                }}
                            >
                                {cardData.services.map((service, index) => (
                                    <div key={index} className=" my-4">
                                        <h4 className="py-1 darkcolorrr">{service.name}</h4>
                                        <p>{service.description}</p>
                                    </div>
                                ))}
                            </div>

                            <table className="table table-responsive Border-key my-2">
                                <tbody className=' Border-key'>
                                    {cardData.tableData.map((row, rowIndex) => (
                                        <tr className='Border-key ' key={rowIndex}>
                                            {row.map((cell, cellIndex) => (
                                                <td key={cellIndex} className=' Border-key bluecolor fw-bold' >{cell}</td>
                                            ))}
                                        </tr>
                                    ))}
                                </tbody>
                            </table>
                            <h3 className='pt-md-3'>{cardData.keyword + " Rates"}</h3>
                            <BusRatesTable />

                            <div id="why-choose-section"
                                className='px-2'>
                                <h2 className='whycolor py-3'>Why Choose us for  {cardData.keyword}</h2>
                                {cardData.whychoose.map((item, index) => (
                                    <div key={index}>
                                        <h4 className="py-1 whycolor">{item.WhyChooseheading}</h4>
                                        <p>{item.WhyChoosedescription}</p>
                                    </div>
                                ))}
                            </div>


                            <div className="row twm-faq-section-1 m-b30">


                                <div className=" col-md-12 wow fadeInDown" data-wow-delay="0.2">
                                    <div className="twm-faq-info-wrap">

                                        <div className="section-head left">
                                            <h2 className="twm-large-title site-text-dark darkcolor">FAQS {cardData.keyword} For Amruta Travels</h2>
                                        </div>


                                        <div className="twm-faq-info">
                                            <div className="accordion twm-acdn" id="sf-faq-accordion">
                                                <FAQKeyword faqs={faqData} />


                                            </div>
                                        </div>
                                    </div>
                                </div>
                            </div>


                            <TestimonialKeyword
                                title="Testimonial"
                                description="Hear what our happy customers have to say about their travel experience with Amruta Travels."
                                reviews={testimonialsData}
                            />

                            <div className='py-4'>

                                <div className="contact-box Borderr">
                                    <h3>{contactData.heading}</h3>
                                    <p className='text-black'>For booking inquiries or any assistance, please feel free to contact us:</p>
                                    <div className="contact-details">
                                        <p><strong className='darkcolor'>Mobile No:</strong></p>
                                        <ul>
                                            {contactData.contactNumbers.map((number, index) => (
                                                <li key={index}>
                                                    <a href={`tel:${number}`} className="contact-link fw-bold fs-5">
                                                        {number}
                                                    </a>
                                                </li>
                                            ))}
                                        </ul>
                                        <p><strong className='darkcolor'>Email Id: </strong>
                                            <a href={`mailto:${contactData.email}`} className="contact-link">
                                                {contactData.email}
                                            </a>
                                        </p>
                                    </div>
                                </div>
                            </div>
                        </div>

                        <div className='col-12 col-md-4' >
                            {Images.map((e) => {
                                return (
                                    <div className="box1">
                                        <a
                                            href="./"
                                            className="d-flex justify-content-around align-items-center"
                                        >
                                            <div className="b1">
                                                <img src={e.place} alt="img" />
                                            </div>
                                            <div className="b2">
                                                {" "}
                                                <a href="./" className='px-3'>{e.text}</a>
                                            </div>
                                        </a>
                                    </div>
                                );
                            })}


                            <div className="gallery-container">
                                <h2 className="gallery-title">Our Fleets</h2>
                                <div className="gallery-row d-flex flex-wrap">
                                    {images.map((image, index) => (
                                        <div className="gallery-item col-md-4" key={index}>
                                            <img
                                                src={image.src}
                                                alt={image.alt}
                                                className="gallery-image"

                                            />
                                        </div>
                                    ))}

                                </div>
                            </div>

                            <div className=" rounded p-4 shadow-sm Uni_border "
                                style={{
                                    cursor: 'pointer',
                                    padding: '10px',
                                    border: '3px dotted #021B3A',
                                    marginBottom: '7px',
                                    fontWeight: 'bold',
                                }}

                            >
                                <h4 className="pb-3 pt-3 lead fw-bold text-dark">Contact Information</h4>

                                <div className="row">

                                    <div className="col-12 mb-3">
                                        <div className="Small_border  rounded text-center py-2 " style={{ backgroundColor: '#021B3A' }}>
                                            <h4 className=" lead fw-semibold whitt text-darkk text-white">Phone Numbers</h4>
                                            <i className="bi bi-telephone-fill fs-1 mb-2"></i>
                                            <div className=''>
                                                <a href="tel:+917353109555" className="d-block  text-white">+91 7353109555</a>
                                                <a href="tel:+917090597555" className="d-block  text-white">+91 7090597555</a>
                                                <a href="tel:+917887774499" className="d-block  text-white">+91 7887774499</a>


                                            </div>
                                        </div>
                                    </div>


                                    <div className="col-12 mb-3 ">
                                        <div className="Small_border rounded text-center">
                                            <i className="bi bi-envelope fs-1 mb-2"></i>
                                            <div className='rounded py-2' style={{ backgroundColor: '#021B3A' }}>
                                                <h4 className=" fw-semibold lead whitt text-darkk text-white">Email</h4>
                                                <a href="mailto:booking@bushireinpune.com" className=" text-white d-block">
                                                    booking@bushireinpune.com
                                                </a>
                                            </div>
                                        </div>
                                    </div>


                                    <div className="col-12 mb-3 ">
                                        <div className="Small_border  rounded text-center">
                                            <i className="bi bi-house-fill fs-1 mb-2"></i>
                                            <div className='rounded py-2' style={{ backgroundColor: '#021B3A' }}>
                                                <h4 className=" fw-semibold lead whitt text-darkk text-white">Address</h4>
                                                <p className="whit text-white ">
                                                    <i> Amruta Travels <br />
                                                        Office No.- 2, Ground Floor, Wings H-(Puram), Prayeja City, Phase-2, Near Prayeja City, Vadgaon Budruk, Pune, Maharashtra - 411041
                                                    </i>
                                                </p>
                                            </div>
                                        </div>
                                    </div>
                                </div>
                            </div>



                        </div>
                    </div>
                </div>
            </section>



        </div>
    );
}

export default Punwtorajashthandarshan;